export default __webpack_public_path__ + "static/media/new_fetch_popup.111f7407.png";